import { AppState } from '../reducers';

const analyticsStateSelector = (state: AppState) => state.analytics;

export const analyticsCurrentPageTypeSelector = (state: AppState) => analyticsStateSelector(state).currentPageType;
